// 根据用户角色获取首页路径
export const getHomePathByUser = (user: {
  isAdmin?: boolean;
  isAspiceSpecialist?: boolean;
  is_admin?: boolean;
  is_aspice_specialist?: boolean;
}) => {
  if (user.isAdmin || user.is_admin) {
    return '/system/overview';
  }
  if (user.isAspiceSpecialist || user.is_aspice_specialist) {
    return '/aspice/overview';
  }
  return '/overview';
};

// 升级主版本号（第一个数字 +1），解析异常返回空字符串
export const upgradeMajorVersion = (version: string): string => {
  const parts = version.split('.');
  if (parts.length < 1 || !parts.every((p) => /^\d+$/.test(p))) {
    return '';
  }
  parts[0] = String(Number(parts[0]) + 1);
  return parts.join('.');
};

// 升级次版本号（第二个数字 +1），解析异常返回空字符串
export const upgradeMinorVersion = (version: string): string => {
  const parts = version.split('.');
  if (parts.length < 2 || !parts.every((p) => /^\d+$/.test(p))) {
    return '';
  }
  parts[1] = String(Number(parts[1]) + 1);
  return parts.join('.');
};

/** 版本号为 x.y，且主版本号 x < 1。 */
export const isSubOneXyVersion = (version?: string): boolean => {
  const text = String(version || '')
    .trim()
    .replace(/^v/i, '');
  const parts = text.split('.');
  if (parts.length !== 2 || !parts.every((part) => /^\d+$/.test(part))) {
    return false;
  }
  return Number(parts[0]) < 1;
};
